<template>
  <div>
    <top-title :name="titleName" style="margin: 20px; min-width: 980px" v-if="titleName === '互动任务' || isTopTitle"></top-title>

    <div class="integralEden">
      <div class="content" v-if="createStep == 1">
        <!-- 头部导航切换 -->
        <div class="navTab" v-if="allHide == true">
          <span class="tab" :class="{ active: tabActive == 1 }" @click="tabActive = 1">创建活动</span>
          <span class="tab" :class="{ active: tabActive == 2 }" @click="tabActive = 2">活动管理</span>
        </div>
        <!-- 创建活动 -->
        <ul class="activity" v-show="tabActive == 1" v-loading="showLoading">
          <li class="item" v-for="(item, index) in activityForm" :key="index" :v-model="activityForm">
            <div class="wrap">
              <!-- <div class="imgBorder">
                
              </div> -->
              <div class="imgBox">
                <img :src="item.scr" class="img" />
              </div>
              <div class="info">
                <span class="tit" style="position: relative;"
                  >{{ item.signed }} <a v-if="item.toltipTrue" class="toltip" :class="{ toltipdecs: item.linear }">{{ item.toltip }}</a></span
                >
                <span class="desc">{{ item.content }}</span>
              </div>
              <div class="btn">
                <button @click="createActivity(item.id, item)">立即创建</button>
              </div>
              <div class="btnBackground"></div>
            </div>
          </li>
        </ul>
        <!-- 活动管理 -->
        <activity-manage
          :actManag="1"
          v-if="tabActive == 2"
          @changeData="changeData"
          @changeStatus="changeStatus"
          :activityList="activityList"
        ></activity-manage>
      </div>

      <!-- 创建活动步骤 -->
      <create-activity-step
        v-if="createStep == 2"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
        @titopName="titopName"
      ></create-activity-step>
      <create-invite-step
        v-if="createStep == 5"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
        @titopName="titopName"
      ></create-invite-step>
      <!-- 电铺礼包千人千面 -->
      <create-task-electric
        v-if="createStep == 3"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
        @titopName="titopName"
      ></create-task-electric>
      <!-- 首单  复购 下单有礼 -->
      <create-task-Polite
        v-if="createStep == 4"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
        @titopName="titopName"
      ></create-task-Polite>
      <create-task-evaluation
        v-if="createStep == 6"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
        @titopName="titopName"
      ></create-task-evaluation>
      <create-task-book
        v-if="createStep == 7"
        @returnBack="returnBackChange"
        @saveEdit="saveEditChange"
        :activityData="activityData"
        @titopName="titopName"
      ></create-task-book>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/top-title";
import createActivityStep from "./points_task_activity";
import createInviteStep from "./points_task_Invite";
import activityManage from "./activityManage";
import createTaskPolite from "./points_task_polite.vue";
import createTaskElectric from "./points_task_electric.vue";
import createTaskEvaluation from "./points_task_evaluation.vue";
import createTaskBook from "./points_task_book.vue";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import { getSellerInfo } from "@/api/sellerController";

export default {
  components: {
    topTitle,
    createActivityStep,
    createInviteStep,
    activityManage,
    createTaskPolite,
    createTaskElectric,
    createTaskEvaluation,
    createTaskBook,
  },
  data() {
    return {
      // 导航选中
      titleName: "互动任务",
      tabActive: 1,
      createStep: 1,
      activityData: null,
      activityForm: [],
      // 活动列表
      activityList: [],
      allHide: true,
      activityUrl: "",
      venderId: "",
      idUrl1: "",
      idUrl2: "",
      idUrl3: "",
      idUrl4: "",
      idUrl5: "",
      idUrl6: "",
      idUrl7: "",
      idUrl8: "",
      idUrl9: "",
      idUrl10: "",
      idUrl11: "",
      isTopTitle: false,
      showLoading: true,
    };
  },
  created() {
    this.prefixQue();
    this.getSellerInfo();
  },
  mounted() {},
  methods: {
    //获取活动地址
    async prefixQue() {
      const res = await prefixurl();
      this.activityUrl = res.data.activityUrl;
      // this.activityUrl = 'http://114.67.239.56:40003'
      this.venderId = res.data.venderId;
      this.idUrl1 = this.activityUrl + "/" + "clientPreview" + "?activityType=11&venderId=" + this.venderId;
      this.idUrl2 = this.activityUrl + "/" + "clientPreview" + "?activityType=11&venderId=" + this.venderId;
      this.idUrl3 = this.activityUrl + "/" + "rob_goodPresent" + "?venderId=" + this.venderId;
      this.idUrl4 = this.activityUrl + "/" + "attention_shop" + "?venderId=" + this.venderId;
      this.idUrl5 = this.activityUrl + "/" + "invitationopenCard" + "?venderId=" + this.venderId;
      this.idUrl6 = this.activityUrl + "/" + "invitationattention" + "?venderId=" + this.venderId;
      this.idUrl7 = this.activityUrl + "/" + "perfect_information" + "?venderId=" + this.venderId;
      this.idUrl8 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId;
      this.idUrl9 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId;
      this.idUrl10 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId;
      this.idUrl11 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId;
      if (this.$route.query.type) {
        const num = Number(this.$route.query.type);
        this.createActivity(num);
      }
    },
    createActivity(type, item) {
      if (type > 26) {
        this.createStep = item.createStep;
        this.titleName = item.signed;
        this.activityData = {
          id: item.id,
          name: item.signed,
          telImg: "",
          telCode: "",
        };
        return;
      }
      // 邀请开卡初始化另一个组件
      if (type == 5) {
        this.createStep = 5;
        this.titleName = "邀请开卡";
        this.activityData = {
          id: 4,
          name: "邀请开卡",
          telImg: require("../../assets/images/integralCenter/kk.jpg"),
          telCode: this.idUrl5,
        };
        return;
      }
      if (type == 15) {
        this.createStep = 3;
        this.activityData = {
          id: 15,
          name: "店铺礼包千人千面",
          telImg: require("../../assets/images/integralCenter/dingzhi.png"),
          telCode: "",
        };
        this.titleName = "店铺礼包千人千面";
        return;
      }
      if (type == 16 || type == 17 || type == 18) {
        this.createStep = 4;
        switch (type) {
          case 16:
            this.activityData = {
              id: 16,
              name: "下单有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: this.idUrl8,
            };
            this.titleName = "下单有礼";
            break;
          case 17:
            this.activityData = {
              id: 17,
              name: "首单专享礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: this.idUrl8,
            };
            this.titleName = "首单专享礼";
            break;
          case 18:
            this.activityData = {
              id: 18,
              name: "复购有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: this.idUrl8,
            };
            this.titleName = "复购有礼";
            break;
        }
        return;
      }
      if (type == 20 || type == 21 || type == 22) {
        this.createStep = 6;
        switch (type) {
          case 20:
            this.activityData = {
              id: 20,
              name: "评价有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: this.idUrl9,
            };
            this.titleName = "评价有礼";
            break;
          case 21:
            this.activityData = {
              id: 21,
              name: "裂变神券",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: this.idUrl10,
            };
            this.titleName = "裂变神券";
            break;
          case 22:
            this.activityData = {
              id: 22,
              name: "天降红包雨",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: this.idUrl11,
            };
            this.titleName = "天降红包雨";
            break;
        }
        return;
      }
      this.createStep = 2;
      switch (type) {
        case 13:
          this.activityData = {
            id: 13,
            name: "开卡礼包",
            telImg: require("../../assets/images/integralCenter/dingzhi.png"),
            telCode: "",
          };
          this.titleName = "开卡礼包";
          break;
        case 14:
          this.activityData = {
            id: 14,
            name: "店铺礼包",
            telImg: require("../../assets/images/integralCenter/dingzhi.png"),
            telCode: "",
          };
          this.titleName = "店铺礼包";
          break;
        case 1:
          this.activityData = {
            id: 1,
            name: "日历签到",
            telImg: require("../../assets/images/integralCenter/日历签到1.png"),
            telImg2: require("../../assets/images/integralCenter/日历签到2.png"),
            telImg3: require("../../assets/images/integralCenter/日历签到3.png"),
            telCode: this.idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "1" }),
            telCode2: this.idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "2" }),
            telCode3: this.idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "3" }),
          };
          this.titleName = "日历签到";
          break;
        case 3:
          this.activityData = {
            id: 2,
            name: "每日抢好礼",
            telImg: require("../../assets/images/integralCenter/mrq.jpg"),
            telCode: this.idUrl3,
          };
          this.titleName = "每日抢好礼";
          break;
        case 4:
          this.activityData = {
            id: 3,
            name: "关注店铺有礼",
            telImg: require("../../assets/images/integralCenter/gzdp.jpg"),
            telCode: this.idUrl4,
          };
          this.titleName = "关注店铺有礼";
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡",
            telImg: require("../../assets/images/integralCenter/kk.jpg"),
            telCode: this.idUrl5,
          };
          this.titleName = "邀请开卡";
          break;
        case 6:
          this.activityData = {
            id: 5,
            name: "邀请关注店铺",
            telImg: require("../../assets/images/integralCenter/yqgz.jpg"),
            telCode: this.idUrl6,
          };
          this.titleName = "邀请关注店铺";
          break;
        case 7:
          this.activityData = {
            id: 6,
            name: "完善信息有礼",
            telImg: require("../../assets/images/integralCenter/wsxx.jpg"),
            telCode: this.idUrl7,
          };
          this.titleName = "完善信息有礼";
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      this.titleName = "互动任务";
      this.isTopTitle = false;
      // this.allHide = true;
      // console.log(this.allHide, "returnBackChange");
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      this.titleName = "互动任务";
      this.isTopTitle = false;
      // this.allHide = true;
      // console.log(this.allHide, "saveEditChange");
    },
    titopName(name, val) {
      this.isTopTitle = val;
      this.titleName = name;
    },
    changeData() {
      this.allHide = false;
    },
    changeStatus() {
      this.allHide = true;
    },
    // 玩法权限
    getSellerInfo() {
      getSellerInfo().then((res) => {
        this.showLoading = false;
        res.data.permissions.forEach((item) => {
          if (item === "card:opening:gift:bag") {
            this.activityForm.push({
              sort: 10,
              id: 13,
              signed: "开卡礼包",
              content: "开卡礼包支持针对会员和非会员人群跳转链接设置",
              scr: require("../../assets/images/integralCenter/icon_kakai.png"),
              toltip: "推荐",
              toltipTrue: true,
            });
          } else if (item === "shop:gift:bag") {
            this.activityForm.push({
              sort: 20,
              id: 14,
              signed: "店铺礼包",
              content: "店铺礼包可以选择目标人群，定向投放，礼品支持京券、东券、京豆、积分",
              scr: require("../../assets/images/integralCenter/jifenrenwu_mrq.png"),
              toltip: "推荐",
              toltipTrue: true,
            });
          } else if (item === "shop:gift:bag:tptn") {
            this.activityForm.push({
              sort: 30,
              id: 15,
              signed: "店铺礼包千人千面",
              content: "店铺礼包可以选择目标人群，定向投放，礼品支持京券、东券、京豆、积分",
              scr: require("../../assets/images/integralCenter/icon_qrqm.png"),
              toltip: "推荐",
              toltipTrue: true,
            });
          } else if (item === "presell:politely") {
            this.activityForm.push({
              sort: 35,
              id: 27,
              signed: "预售有礼",
              content: "预售有礼可帮助商家提升搜索曝光量，并且可根据预售订单的笔数及金额设置相应奖励。",
              scr: require("../../assets/images/integralCenter/icon_mrqhl.png"),
              toltip: "双11必备",
              toltipTrue: true,
              createStep: 7,
              linear: true,
            });
          } else if (item === "presell:lottery") {
            this.activityForm.push({
              sort: 36,
              id: 28,
              signed: "预售抽奖",
              content: "通过预售抽奖权益，商家可对会员进行预售奖励，根据奖项的不同可以设置不同的中奖概率，有效提高用户的参与积极性从而提升会员转化。",
              scr: require("../../assets/images/integralCenter/icon_yscj.png"),
              toltip: "双11必备",
              createStep: 7,
              toltipTrue: true,
              linear: true,
            });
          } else if (item === "order:politely") {
            this.activityForm.push({
              sort: 40,
              id: 16,
              signed: "下单有礼",
              content: "通过下单有礼权益，商家可对会员进行下单奖励，从而有效的提升会员转化、复购率。",
              scr: require("../../assets/images/integralCenter/icon_xdyl.png"),
              toltip: "推荐",
              toltipTrue: true,
            });
          } else if (item === "first:purchase:courtesy") {
            this.activityForm.push({
              sort: 50,
              id: 17,
              signed: "首单专享礼",
              content: "通过首单专享礼权益，商家可对会员进行首单奖励，从而有效的提升会员转化、复购率。",
              scr: require("../../assets/images/integralCenter/icon_sgyl.png"),
              toltip: "推荐",
              toltipTrue: true,
            });
          } else if (item === "repurchase:courtesy") {
            this.activityForm.push({
              sort: 60,
              id: 18,
              signed: "复购有礼",
              content: "通过复购有礼权益，商家可对会员进行复购奖励，从而有效的提升会员转化、复购率。",
              scr: require("../../assets/images/integralCenter/icon_fgyl.png"),
              toltip: "推荐",
              toltipTrue: true,
            });
          } else if (item === "evaluate:politely") {
            this.activityForm.push({
              sort: 70,
              id: 20,
              signed: "评价有礼",
              content: "通过礼品激励买家进行评价，买家好评后可参与抽奖赢取礼品，快速提升店铺DSR",
              scr: require("../../assets/images/integralCenter/icon_pjyl.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "fission:divine:voucher") {
            this.activityForm.push({
              sort: 80,
              id: 21,
              signed: "裂变神券",
              content: "通过社交分享，邀请好友组团领券，成功裂变涨粉",
              scr: require("../../assets/images/integralCenter/icon_lbsq.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "sky:fall:redpack:rain") {
            this.activityForm.push({
              sort: 90,
              id: 22,
              signed: "天降红包雨",
              content: "倒计时接红包，根据接红包的个数获得奖品，活跃店铺气氛",
              scr: require("../../assets/images/integralCenter/icon_tjhby.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "calendar:check:in") {
            this.activityForm.push({
              sort: 100,
              id: 1,
              signed: "日历签到",
              content: "支持每日签到、连续签到、累计签到多种赠送方式，增强会员粘性",
              scr: require("../../assets/images/integralCenter/icon_mrhl.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "grab:good:gifts:every:day") {
            this.activityForm.push({
              sort: 110,
              id: 3,
              signed: "每日抢好礼",
              content: "限时限量发放好礼，制造紧迫感，吸引会员定时参与店铺活动",
              scr: require("../../assets/images/integralCenter/icon_mrqhl.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "follow:shop:polite") {
            this.activityForm.push({
              sort: 120,
              id: 4,
              signed: "关注店铺有礼",
              content: "关注店铺赢好礼，可增加店铺关注量，提升店铺权重，支持设置曝光商品，刺激转化提客户粘性，推广店铺必推玩法",
              scr: require("../../assets/images/integralCenter/icon_gzyl.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "invitation:card:opening") {
            this.activityForm.push({
              sort: 130,
              id: 5,
              signed: "邀请开卡",
              content: "引导客户邀请好友开卡，迅速增加活动曝光率，提升店铺流量，提升转化率",
              scr: require("../../assets/images/integralCenter/icon_yq.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "invite:follow:store") {
            this.activityForm.push({
              sort: 140,
              id: 6,
              signed: "邀请关注店铺",
              content: "引导客户邀请好友关注店铺，迅速增加活动曝光率，提升店铺流量，提升转换率",
              scr: require("../../assets/images/integralCenter/icon_gzdp.png"),
              toltip: "",
              toltipTrue: false,
            });
          } else if (item === "improve:information:courtesy") {
            this.activityForm.push({
              sort: 150,
              id: 7,
              signed: "完善信息有礼",
              content: "收集店铺会员信息，提交后赠送礼品，完善店铺会员标签",
              scr: require("../../assets/images/integralCenter/icon_ws.png"),
              toltip: "",
              toltipTrue: false,
            });
          }
        });
        // 排序
        this.activityForm.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .content {
    min-height: 980px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #7b61ff;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #7b61ff;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
    .activity {
      display: flex;
      flex-wrap: wrap;
      align-content: baseline;
      box-sizing: border-box;
      padding: 30px 14px;
      list-style: none;
      min-height: 500px;
      min-width: 1366px;
      .item {
        position: relative;
        flex: 1;
        // max-width: 31.63%;
        // min-width: 31.63%;
        max-width: 31.63%;
        min-width: 31.63%;
        box-sizing: border-box;
        margin: 0 14px;
        margin-bottom: 20px;
        // flex-shrink: 1;
        .wrap {
          display: flex;
          box-sizing: border-box;
          padding: 0 14px;
          height: 200px;
          // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          // border: 1px solid #eee;
          box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
          background-color: #fff;
          transition: all 0.2s;
          .btn {
            display: none;
            opacity: 0;
          }
          &:hover {
            // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
            border: 1px solid #7b61ff;
            // opacity: 1;
            .btn {
              display: inline;
              opacity: 1;
              z-index: 100;
              position: absolute;
              left: 50%;
              top: 50%;
              margin: -16px 0 0 -47px;
              text-align: right;
              button {
                width: 94px;
                height: 32px;
                line-height: 28px;
                text-align: center;
                border-radius: 3px;
                border: 1px;
                color: #7b61ff;
                background-color: #7b61ff;
                color: #fff;
                cursor: pointer;
                outline: none;
                transition: all 0.2s;
                &:hover {
                  background-color: #fa6c6c;
                  color: #fff;
                }
              }
            }
            .btnBackground {
              border-radius: 6px;
              position: absolute;
              top: 15px;
              left: 2px;
              flex: 1;
              width: 98%;
              // min-width: 100%;
              box-sizing: border-box;
              padding: 14px;
              margin-bottom: 20px;
              height: 90%;
              background: rgb(255, 255, 255);
              opacity: 0.7;
            }
          }
          // .imgBorder {
          //   border: 1px solid #ffe8ce;
          //   background: #ffe8ce;
          //   border-radius: 40px;
          //   height: 80px;
          //   opacity: 1;
          //   position: absolute;
          //   top: 50%;
          //   margin: -40px 0 0 20px;
          //   width: 80px;
          // }
          .imgBox {
            .img {
              position: absolute;
              // flex-shrink: 0;
              top: 50px;
              left: 26px;
              width: 80px;
              height: 80px;
              margin: 9px 0 0 9px;
            }
          }
          .info {
            margin-left: 120px;
            // flex: 1;
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            padding: 30px 0 16px 0;
            margin-top: 28px;
            .tit {
              margin-top: 30px;
              font-size: 16px;
              color: #333;
              .toltip {
                position: absolute;
                top: -19px;
                right: -45px;
                width: 40px;
                height: 22px;
                background: #7b61ff;
                // box-shadow: 0px 2px 4px rgba(254 77 69 40%);
                // box-shadow: 0px 2px 4px rgba(254, 77, 69, 40%);
                box-shadow: 0px 2px 4px rgba(254, 77, 69, 0.4);
                border-radius: 43px 43px 43px 4px;
                font-size: 14px;
                text-align: center;
                line-height: 22px;
                color: #fff;
              }
              .toltipdecs {
                background-image: linear-gradient(to right, #c75af0, #5b9aff);
                width: 73px;
                right: -77px;
                box-shadow: 0px 2px 4px rgba(143, 121, 229, 0.4);
              }
            }
            .desc {
              display: block;
              margin-top: 15px;
              font-size: 14px;
              line-height: 24px;
              color: #333;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1401px) and (max-width: 1800px) {
  .item {
    max-width: 40.63% !important;
    min-width: 31.63% !important;
  }
}
@media (min-width: 1366px) and (max-width: 1400px) {
  .item {
    max-width: 39.63% !important;
    min-width: 31.63% !important;
  }
}
@media (min-width: 1280px) and (max-width: 1366px) {
  .item {
    max-width: 36.63% !important;
    min-width: 31.63% !important;
    // line-height: 0px;
  }
}
// @media screen and (max-width: 1279px) {
//   .item {
//     max-width: 31.63% !important;
//     min-width: 31.63% !important;
//   }
// }
</style>
